import {BaseDTO} from '@/app/dto/BaseDTO';
import {FileDTO} from '@/app/dto/FileDTO';
import {TranslationDTO} from '@/app/dto/TranslationDTO';
import {CastableProperties} from '@/app/utils/Castable';
import {FabricDTO} from "@/app/dto/FabricDTO";
import {BaseProjectDTO} from "@/app/dto/BaseProjectDTO";

export class RfqProductDTO extends BaseDTO {

    public createdAt: Date = null;

    public name: string = null;
    public description: TranslationDTO = null;

    public category: string = null;

    public targetPrice: number = null;
    public targetQuantity: number = null;

    public targetDeliveryDate: Date = null;

    public fabrics: FabricDTO[] = [];
    public hasFabrics: boolean = null;

    public offerCount: number = null;

    public hasTechpack: boolean = null;

    public techpackAssistance: boolean = null;
    public techpack: FileDTO[] = null;
    public techpackUrl: string = null;

    public project: BaseProjectDTO = null;

    protected static get castParams(): CastableProperties {
        return {
            ...super.castParams,
            description: TranslationDTO,
            targetDeliveryDate: Date,
            fabrics: [FabricDTO],
            techpack: [FileDTO],
            project: BaseProjectDTO,
        };
    }

}
